module.exports = __webpack_public_path__ + "img/youtube.c55dfac5.svg";